import { useEffect, useState } from "react";

const Loader = () => {
  const [dots, setDots] = useState(0);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const dotsInterval = setInterval(() => {
      setDots((prev) => (prev + 1) % 4);
    }, 500);

    // Simulate progress for the progress bar
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev < 95) {
          return prev + Math.random() * 5;
        }
        return prev;
      });
    }, 700);

    return () => {
      clearInterval(dotsInterval);
      clearInterval(progressInterval);
    };
  }, []);

  return (
    <div
      className="flex items-center justify-center"
      style={{ minHeight: "calc(100vh - 265px)" }}
    >
      <div className="w-full max-w-md p-8 rounded-lg shadow-md bg-white border border-gray-200">
        {/* Professional Loader Animation */}
        <div className="flex justify-center mb-8">
          <div className="relative w-16 h-16">
            {/* Outer ring */}
            <div className="absolute inset-0 border-4 border-gray-100 rounded-full"></div>

            {/* Spinning arc */}
            <div className="absolute inset-0 border-4 border-transparent border-t-blue-600 rounded-full animate-spin"></div>

            {/* Secondary spinning arc */}
            <div
              className="absolute inset-0 border-4 border-transparent border-b-blue-400 rounded-full"
              style={{
                animation: "spin 1.2s linear infinite reverse",
                opacity: 0.7,
              }}
            ></div>

            {/* Center dot */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-3 h-3 bg-blue-600 rounded-full"></div>
            </div>
          </div>
        </div>

        {/* Text Content */}
        <div className="text-center mb-6">
          <h2 className="text-lg BookEZ_font_body_medium text-gray-800 mb-2">
            Processing Data
            <span className="text-blue-600">{".".repeat(dots)}</span>
            <span className="opacity-0">{".".repeat(3 - dots)}</span>
          </h2>
          <p className="BookEZ_font_body_size  text-gray-500">
            Please wait while we validate your financial information
          </p>
        </div>

        {/* Progress bar */}
        <div className="w-full h-1.5 bg-gray-100 rounded-full overflow-hidden mb-4">
          <div
            className="h-full bg-blue-600 rounded-full transition-all duration-300 ease-out"
            style={{ width: `${progress}%` }}
          ></div>
        </div>

        {/* Progress percentage */}
        <div className="text-right text-xs text-gray-400 font-mono">
          {Math.round(progress)}%
        </div>
      </div>
    </div>
  );
};

export default Loader;
